// Import Swiper React components
import { ClientOnly } from "remix-utils/client-only";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useMediaQuery } from "usehooks-ts";

import type { ImageType } from "~/components/common/images";
import Image from "~/components/common/images";

export interface PartnersSliderProps {
  partners: {
    id: string;
    url?: string;
    logo?: ImageType;
  }[];
}

const PartnerSlideFallback = ({ partners }: PartnersSliderProps) => (
  <div className="flex gap-[30px]">
    {partners.map((partner) => {
      const imageRendered = partner.logo && (
        <div
          key={partner.id}
          className="flex h-[62px] w-full items-center justify-center"
        >
          <Image
            image={partner.logo}
            alt=""
            className="size-full object-contain"
          />
        </div>
      );

      return partner.url ? (
        <a target="_blank" href={partner.url} rel="noreferrer">
          {imageRendered}
        </a>
      ) : (
        imageRendered
      );
    })}
  </div>
);

const PartnersSlider = ({ partners }: PartnersSliderProps) => {
  const md = useMediaQuery("(min-width: 768px)");

  return (
    <section className="w-full md:mt-[55px]">
      <h3 className="mb-[20px] text-center text-md">Trusted by the best</h3>
      <div className="rounded-lg border border-purple bg-white p-[30px]">
        <ClientOnly fallback={<PartnerSlideFallback partners={partners} />}>
          {() => (
            <Swiper
              spaceBetween={30}
              slidesPerView={md ? 6 : 2}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              loop={true}
              modules={[Autoplay]}
            >
              {partners.map((partner) => {
                const imageRendered = partner.logo && (
                  <div className="flex h-[62px] w-full items-center justify-center">
                    <Image
                      image={partner.logo}
                      alt=""
                      className="size-full object-contain"
                    />
                  </div>
                );
                return (
                  <SwiperSlide key={partner.id}>
                    {partner.url ? (
                      <a target="_blank" href={partner.url} rel="noreferrer">
                        {imageRendered}
                      </a>
                    ) : (
                      imageRendered
                    )}
                  </SwiperSlide>
                );
              })}
            </Swiper>
          )}
        </ClientOnly>
      </div>
    </section>
  );
};

export default PartnersSlider;
